module.exports = __webpack_public_path__ + "pattern/highlight-top-right.704056.svg";